import State from './state';

export function setLearnSkillList(state, data) {
  state.learn_skill_list = data.data;
}

export function setPlanSkillList(state, data) {
  state.plan_skill_list = data.data;
}

export function setGoalsSkillList(state, data) {
  state.goals_skill_list = data.data;
}

export function setRateSkillList(state, data) {
  state.rate_skill_list = data.data;
}

export function setLearnSkillState(state, error) {
  state.error = error;
}

export function setSkillName(state, data) {
  state.skill_name = data.data;
}

export function setSkillDescription(state, data) {
  state.skill_description = data.data;
}

export function setPlanQuestionList(state, data) {
  state.plan_question_list = data.data;
}

export function setPlanAnswers(state, data) {
  state.plan_answers = data.data;
}

export function setRateQuestionList(state, data) {
  state.rate_question_list = data.data;
}

export function setPracticeQuestionList(state, data) {
  state.practice_question_list = data.data;
}

export function setRateSkillState(state, error) {
  state.error = error;
}

export function setSkillPlan(state, error) {
  state.error = error;
}

export function setQuestionsToSkip(state, data) {
  state.questions_to_skip = data.data;
}

export function setRelatedPlanAnswers(state, data) {
  state.related_plan_answers = data;
}

export function setPracticeAnswers(state, data) {
  state.practice_answers = data.data;
}

export function setSkillPractice(state, error) {
  state.error = error;
}

export function removeSkillFromSkillList(state = State, skillId) {
  const skillsFiltered =
    state.goals_skill_list?.skills?.filter((skill) => skill.id !== skillId) || [];
  state.goals_skill_list = { ...state.goals_skill_list, skills: skillsFiltered };
}

export function cleanErrors(state) {
  state.error = '';
}

export function error(state, error) {
  state.error = error;
}
